module.exports = __webpack_public_path__ + "static/media/img_12-1.ec43c201.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/img_12-1.png
// module id = 709
// module chunks = 0